

/** Application question interactions */
export class ApplyQuestion {
  /**
   * Enhance a given apply question
   * @param {object} $question DOM element of the wrapping question group
   */
  constructor($question) {
    this.$question = $question;
    this.$labels = $('label', this.$question);

    this.$labels
      .find(':checked')
      .closest('label')
      .addClass('is-selected');
    this.$labels.on('click', this.setSelected.bind(this));
  }

  /**
   * Applies styling for selected question
   * @param {object} event Listener event
   */
  setSelected(event) {
    this.$labels.removeClass('is-selected');
    $(event.target)
      .closest('label')
      .addClass('is-selected');
  }
}
